import BaseSeparator from "./BaseSeparator.vue";

export default BaseSeparator;
